import soundFile from 'src/assets/sounds/join-notification.mp3'

/**
 * ベル音を再生する
 */
export const playBellSound = async (): Promise<void> => {
  try {
    const audio = new Audio(soundFile)
    audio.volume = 0.5
    await audio.play()
  } catch {
    // 通話機能に影響させない
  }
}
